export enum typesConfig {
    ByPriority = 1,
    ByPercentage = 2,
}

export enum ERRORS_TYPES_DOCS {
    MISSING_DOCS = 'Falta documentación',
    REJECTED_DOCS = 'Tiene documentos rechazados',
}
